module.exports = __webpack_public_path__ + "static/media/logo-licitardigital.cea54de2.svg";